"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInputGroup = void 0;
var _ykbStyledComponents = _interopRequireWildcard(require("../../ykb-styled-components"));
var _StyledTextInput = require("../../TextInput/StyledTextInput");
var _StyledTextarea = require("../../Textarea/StyledTextarea");
var _col = require("../../Grid/col");
var _StyledInputHoc = require("./StyledInputHoc");
var _StyledSelect = require("../../Select/StyledSelect");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledInputGroup = exports.StyledInputGroup = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1ceol2-0"
})(["", ";> ", "{padding:0;", ",", ",", ".focus-all,", "{border-radius:0;}", "{border-radius:0;}}", "{border-radius:0;border-right:0;}> ", ":last-child{", ",", ",", ".focus-all,", "{border-radius:0 ", " ", " 0 !important;}", "{border-radius:0 ", " ", " 0 !important;border-right:", ";}", "{", ":last-child{border-radius:0 ", " ", " 0 !important;}*:first-child{border-radius:0 !important;}}}> ", ":first-child{", ",", ",", ".focus-all,", "{border-radius:", " 0 0 ", " !important;}", "{border-radius:", " 0 0 ", " !important;}", "{", ":first-child{border-radius:", " 0 0 ", " !important;}*:last-child{border-radius:0 !important;}}}"], function (props) {
  return props.theme.mixins.clearFix(_ykbStyledComponents.css);
}, _col.StyledCol, _StyledTextInput.StyledInput, _StyledTextarea.StyledTextarea, _StyledTextInput.StyledInputGroup, _StyledSelect.StyledSelection, _StyledTextInput.StyledInputAddon, _StyledInputHoc.StyledViewModeValue, _col.StyledCol, _StyledTextInput.StyledInput, _StyledTextarea.StyledTextarea, _StyledTextInput.StyledInputGroup, _StyledSelect.StyledSelection, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.theme.borderRadiusBase;
}, _StyledInputHoc.StyledViewModeValue, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.theme.form.viewMode.border;
}, _StyledTextInput.StyledInputAddonWrapper, _StyledTextInput.StyledInputAddon, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.theme.borderRadiusBase;
}, _col.StyledCol, _StyledTextInput.StyledInput, _StyledTextarea.StyledTextarea, _StyledTextInput.StyledInputGroup, _StyledSelect.StyledSelection, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.theme.borderRadiusBase;
}, _StyledInputHoc.StyledViewModeValue, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.theme.borderRadiusBase;
}, _StyledTextInput.StyledInputAddonWrapper, _StyledTextInput.StyledInputAddon, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.theme.borderRadiusBase;
});